module.exports = __webpack_public_path__ + "img/icon4.31f1e143.png";